import { round } from 'mathjs';

export const NumberHelper = {
  formatNumber: (input: string | number | boolean | null | undefined, roundPrecision?: number) => {
    if (input == undefined) return '';
    const parsedValue = parseFloat(`${input}`.replace(/\s+/g, ''));

    const value = roundPrecision ? `${round(parsedValue, roundPrecision)}` : `${parsedValue}`;

    const decimalSeparator = value.includes(',') ? ',' : '.';
    const [integer, decimal] = value.split(decimalSeparator);
    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return decimal !== undefined ? `${formattedInteger}${decimalSeparator}${decimal}` : formattedInteger;
  },
};
